import { render, staticRenderFns } from "./CareerPage.vue?vue&type=template&id=54ffe288&scoped=true"
import script from "./CareerPage.vue?vue&type=script&lang=js"
export * from "./CareerPage.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=54ffe288&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ffe288",
  null
  
)

export default component.exports